var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50016 5.66674L2.8335 11.3334V14.1667H5.66683L11.3335 8.50006M8.50016 5.66674L10.5321 3.63477L10.5334 3.63357C10.813 3.35386 10.9531 3.21376 11.1146 3.16129C11.2569 3.11506 11.4101 3.11506 11.5524 3.16129C11.7138 3.21372 11.8538 3.35366 12.1331 3.63297L13.3654 4.86533C13.6459 5.14585 13.7862 5.28617 13.8388 5.4479C13.8851 5.59016 13.885 5.7434 13.8388 5.88567C13.7863 6.04728 13.6462 6.18739 13.3661 6.4675L13.3654 6.46811L11.3335 8.50006M8.50016 5.66674L11.3335 8.50006",
    stroke: "black",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/editPencil.6f51fd9302958accf40ccbabe22b22b2.svg";
export { ForwardRef as ReactComponent };